import type { FC } from 'react';

import { useScreen } from '../../hooks/use-screen/use-screen';
import type { SimpleCompanyItem } from '../../types';
import { SimpleCompanyCard } from '../simple-company-card/simple-company-card';
import * as Styled from './simple-company-card-grid.styled';

type SimpleCardGridProps = {
  items: SimpleCompanyItem[];
  limit: number;
  loading?: boolean;
};

export const SimpleCompanyCardGrid: FC<SimpleCardGridProps> = ({
  items,
  limit,
  loading,
}) => {
  const { isSmallScreen } = useScreen();
  return (
    <Styled.Grid>
      {loading &&
        Array.from({ length: limit }).map((_, index) => (
          <SimpleCompanyCard.Skeleton key={index} horizontal={isSmallScreen} />
        ))}
      {items.map((company) => (
        <SimpleCompanyCard
          key={company.id}
          item={company}
          horizontal={isSmallScreen}
        />
      ))}
    </Styled.Grid>
  );
};
